var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "38", height: "38", viewBox: "0 0 38 38", xmlns: "http://www.w3.org/2000/svg", stroke: "#fff" }, props),
    React.createElement(
      "g",
      { transform: "translate(1 1)", strokeWidth: "2", fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { strokeOpacity: ".5", cx: "18", cy: "18", r: "18" }),
      React.createElement(
        "path",
        { d: "M36 18c0-9.94-8.06-18-18-18" },
        React.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 18 18", to: "360 18 18", dur: "1s", repeatCount: "indefinite" })
      )
    )
  );
});